export const initialState = {
  showSpinner: false
};
